import { render, staticRenderFns } from "./header-detail.vue?vue&type=template&id=368fad2d&scoped=true"
import script from "./header-detail.vue?vue&type=script&lang=js"
export * from "./header-detail.vue?vue&type=script&lang=js"
import style0 from "./header-detail.vue?vue&type=style&index=0&id=368fad2d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368fad2d",
  null
  
)

export default component.exports